var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconISequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-i-sequence") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.11,
    width: 17.78,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.11,
    y: 5.56,
    width: 7.78,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.11,
    y: 5.56,
    width: 7.78,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.11,
    y: 10,
    width: 7.78,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.11,
    y: 10,
    width: 7.78,
    height: 2.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.06,15.28v2.78H.83V15.28H8.06m.83-.83H0v4.44H8.89V14.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.17,15.28v2.78H11.94V15.28h7.22m.83-.83H11.11v4.44H20V14.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconISequence);
export default __webpack_public_path__ + "static/media/icon-i-sequence.e6c6bd50f78a171ecaab8fc82b44f0df.svg";
export { ForwardRef as ReactComponent };